export const GET_STATISTICS_POPULAR_CAPTAINS = "GET_STATISTICS_POPULAR_CAPTAINS";
export const CLEAR_FILTERS_POPULAR_CAPTAINS = "CLEAR_FILTERS_POPULAR_CAPTAINS";